import React from 'react';

interface UnderConstructionProps {
    title?: string;
    description?: string;
    song?: string;
}

const UnderConstruction: React.FC<UnderConstructionProps> = ({ 
        title = '',
        description = '',
        song = ''
    }) => {
        return (
            <div className="starry-bg min-h-screen flex items-center justify-center overflow-hidden bg-black relative font-sans">

                <div className="relative z-10 w-full max-w-2xl mx-auto px-6 py-12 text-center">
                    <div className="backdrop-blur-2xl bg-white/[0.03] rounded-[2rem] p-8 md:p-10 border border-blue-500/20 shadow-[0_0_50px_rgba(59,130,246,0.15)] relative overflow-hidden group">
                        <div className="mb-8">
                            <h1 className="text-sm font-bold tracking-[0.5em] text-blue-500 uppercase mb-2">System Status</h1>
                            <h2 className="text-4xl md:text-5xl font-black bg-gradient-to-r from-white via-blue-200 to-blue-400 bg-clip-text text-transparent leading-tight">
                                {title}
                            </h2>
                        </div>

                        <div className="relative mx-auto max-w-md group-hover:scale-[1.01] transition-transform duration-500">
                            <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-xl blur opacity-20 group-hover:opacity-40 transition duration-1000"></div>
                            <div className="relative bg-black rounded-xl overflow-hidden border border-white/10">
                                <iframe
                                    className="w-full aspect-video opacity-80 hover:opacity-100 transition-opacity duration-300"
                                    src={song}
                                    allowFullScreen
                                />
                            </div>
                        </div>

                        <div className="mt-8 space-y-4">
                            <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-xs md:max-w-sm mx-auto">
                                {description}
                            </p>

                            <div className="flex flex-col items-center pt-4">
                                <div className="flex space-x-1.5">
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-[bounce_1s_infinite_0ms]" />
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-[bounce_1s_infinite_200ms]" />
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-300 animate-[bounce_1s_infinite_400ms]" />
                                </div>
                                <span className="text-[10px] font-mono text-blue-500/60 mt-4 tracking-widest uppercase">
                                    Initializing K-Project Protocols...
                                </span>
                            </div>
                        </div>

                        <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-blue-500/30 rounded-tl-3xl" />
                        <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-blue-500/30 rounded-br-3xl" />
                    </div>
                </div>
            </div>
        );
    };

export default UnderConstruction;